module.exports = __webpack_public_path__ + "static/media/store-no-connection.b4505a00.svg";